export function LoadingScreen({ message = "Loading..." }: { message?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center bg-[#fafaf7]">
      <div>
        <div className="text-xs font-bold tracking-widest text-rwb-red mb-3">TEAM RWB</div>
        <div className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-zinc-300 border-t-rwb-red mb-3" />
        <div className="text-sm text-zinc-500">{message}</div>
      </div>
    </div>
  );
}
